import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    headerTitle: translate({ id: 'settings.gpsAccount.view.headerTitle' }),
    headerDescription: translate({ id: 'settings.gpsAccount.view.headerDescription' }),

    username: translate({ id: 'settings.gpsAccount.view.username' }),
    email: translate({ id: 'settings.gpsAccount.view.email' }),
    timezone: translate({ id: 'settings.gpsAccount.view.timezone' }),
  }))

  return api
}
